export const locale = {
    lang: 'fr',
    data: {
        HEADER: {
            'LOGIN': 'Se connecter',
            'APPLICATION': 'Apps',
            'PROFILE': 'Profil',
            'SETTINGS': 'ParamÃ¨tres',
            'LOGOUT': 'DÃ©connexion',
        },
        FOOTER: {
            'ALL_RIGHTS_RESERVED': 'Tous droits rÃ©servÃ©s',
        }
    }
};
